module.exports = __webpack_public_path__ + "static/img/continueModalImg.d72ca0bd.svg";